'use strict'

import {
  Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
  dom,
  flush
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
  html
} from '@polymer/polymer/lib/utils/html-tag.js'

import {
  PaperDialogBehavior
} from '@polymer/paper-dialog-behavior/paper-dialog-behavior.js'

import '@polymer/paper-button/paper-button'
import '@polymer/paper-dialog-scrollable/paper-dialog-scrollable'
import '@polymer/paper-dialog/paper-dialog'
import '@polymer/app-layout/app-toolbar/app-toolbar'
import '@polymer/app-layout/app-header/app-header'
import '@polymer/app-layout/app-header-layout/app-header-layout'
import '@polymer/paper-tabs/paper-tabs'
import '@polymer/paper-tabs/paper-tab'
import '@polymer/neon-animation/animations/scale-up-animation'
import '@polymer/neon-animation/animations/fade-out-animation'
import '@polymer/iron-ajax/iron-ajax'
import '@polymer/iron-icon/iron-icon'
import '@polymer/iron-pages/iron-pages'
import '@moskito/moskito-song-lyrics/moskito-song-lyrics'
import '@moskito/moskito-song-chordpro/moskito-song-chordpro'

Polymer({
  is: 'song-details-dialog',
  _template: html`
<style includes="paper-dialog-shared-styles">
:host {
    display: block;
    top:0px;
    left: 0px;
    position: absolute;
    --paper-tab-ink: var(--paper-blue-grey-100);
    color: var(--body-text-color);
}
app-header-layout {
  margin: 0;
  height: 80vh;
}
paper-tabs {
    --paper-tabs-selection-bar-color: var(--paper-blue-grey-100);
}
paper-tab {
    text-transform: uppercase;
}
.self-end {
    /* This mixin (from iron-flex-layout) aligns the tabs to the
      bottom of the toolbar. */
    @apply --layout-self-end;
}
.scrollable {
    @apply --layout-flex;
    margin-top: 0;
}
app-toolbar, app-header {
      color: white;
    }
app-toolbar {
    margin-top: 0;
    background: var(--paper-blue-grey-500);
}
paper-button {
    color: var(--paper-blue-grey-500)
}
.fit {
    @apply --layout-fit
}
#media {
    margin-top: 12px
}
paper-tab iron-icon {
    margin-right:6px
}
.harco_purchase_btn {
  background-color: var(--paper-indigo-500);
  color: white;
}

</style>
<paper-dialog id="dialog" style="width:80vw">
    <iron-ajax url="{{url}}" last-response="{{data}}" handle-as="json" id="ajax"
                on-response="handleResponse"></iron-ajax>
    <app-header-layout has-scrolling-region>
    <app-header slot="header" fixed>
    <app-toolbar>
      <div>
            <template is="dom-repeat" items="[[data.data.attributes.authors]]">
                [[item.name]]
            </template>
        </div>
        <div main-title></div>
        <div><h2>[[data.data.attributes.legacy_id]]</h2></div>
    </app-toolbar>
    <app-toolbar>
        <h2 main-title>[[data.data.attributes.title.display.main]]</h2>
    </app-toolbar>
    <app-toolbar>
      <div class="bottom self-end" bottom-item>
        <paper-tabs selected="{{selected}}" id="song_details_tabs" fit-container>
            <paper-tab><iron-icon icon="editor:format-quote"></iron-icon>{{ _translate('Song|Lyrics') }}</paper-tab>
            <paper-tab><iron-icon icon="image:music-note"></iron-icon>{{ _translate('Chords') }}</paper-tab>
            <paper-tab><iron-icon icon="av:music-video"></iron-icon>{{ _translate('Media') }}</paper-tab>
            <paper-tab><iron-icon icon="icons:info-outline"></iron-icon>{{ _translate('Details') }}</paper-tab>
        </paper-tabs>
      </div>
    </app-toolbar>
    </app-header>
    <div class="scrollable">
    <paper-progress indeterminate id="songloadprogress" class="width-100-percent"></paper-progress>
        <iron-pages class="flex" selected="{{selected}}" id="song_details_pages">
            <div>
                <moskito-song-lyrics lyrics="[[data.data.attributes.full_lyrics]]"></moskito-song-lyrics>
            </div>
            <div>
                <moskito-song-chordpro lyrics="[[data.data.attributes.full_lyrics]]" id="moskito-song-chordpro"></moskito-song-chordpro>
            </div>
            <div>
                <div id="media"></div>
            </div>
            <div>
                <moskito-song-details data="[[data.data.attributes]]"
                                      extra="[[data.included]]"
                                      id="moskito-song-details"></moskito-song-details>
            </div>
        </iron-pages>
        </div>
        </app-header-layout>
        <div class="paper-dialog-buttons buttons end">
            <template is="dom-if" if="[[data.data.attribute.can_edit]]">
                <paper-button on-click="edit"><iron-icon icon="icons:launch"></iron-icon>{{ _translate('Edit') }}</paper-button>
            </template>
            <paper-button dialog-confirm autofocus><iron-icon icon="icons:close"></iron-icon>{{ _translate('Close') }}</paper-button>
        </div>


</paper-dialog>
  `,
  behaviors: [PaperDialogBehavior],
  properties: {
    url: {
      value: null,
      notify: true
    }
  },
  _renderOpened: function () {
    this.selected = 0
    while (this.$.media.firstChild) {
      this.$.media.removeChild(this.$.media.firstChild)
    }
    this.$.ajax.generateRequest()
    this.$.dialog.fit()
    this.$.dialog.center()
    this.$.dialog.open()
  },
  _renderClosed: function () {
    this.$.ajax.data = null
    this.$.song_details_tabs.selected = 0
  },
  handleResponse: function () {
    this.$.songloadprogress.hidden = true
    this.$.dialog.fit()
    this.$.dialog.center()
    for (var i = 0, len = this.data.data.attributes.oembed.length; i < len; i++) {
      var embed = document.createElement('div')
      embed.className += 'flex h-spaced v-spaced'
      embed.style.textAlign = 'center'
      embed.innerHTML = this.data.data.attributes.oembed[i]['embed']
      this.$.media.appendChild(embed)
    }
  },
  edit: function (e) {
    window.location.href = this.data.data.attributes.edit_url
  },
  _translate: function (string) {
    return window.__(string)
  }
})
